import script from "./VButtonDropdownMacros.vue?vue&type=script&setup=true&lang=ts"
export * from "./VButtonDropdownMacros.vue?vue&type=script&setup=true&lang=ts"

import "./VButtonDropdownMacros.vue?vue&type=style&index=0&id=02def5b1&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02def5b1"]])

export default __exports__